import { render, staticRenderFns } from "./LinTable.vue?vue&type=template&id=5b34da76&scoped=true"
import script from "./LinTable.vue?vue&type=script&lang=js"
export * from "./LinTable.vue?vue&type=script&lang=js"
import style0 from "./LinTable.vue?vue&type=style&index=0&id=5b34da76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b34da76",
  null
  
)

export default component.exports